export const MANAGERIAL_REPORT_API = `v1/managerial-reports`;
export const FILTER_VARIANT_API = `${MANAGERIAL_REPORT_API}/filter-variants`;